import { render, staticRenderFns } from "./AppAdd.vue?vue&type=template&id=f23f6bf8&scoped=true"
import script from "./AppAdd.vue?vue&type=script&lang=js"
export * from "./AppAdd.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AppAdd.vue?vue&type=style&index=1&id=f23f6bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23f6bf8",
  null
  
)

export default component.exports